import { PlayerSizesTypes } from '../../../common/store/store.types';
import { flexColumnCenterCenter, flexColumnStart } from '../../../common/styles/flex';
import { SITE_VARIABLES } from '../../../common/styles/variables';

interface StylesObject {
  replayBigCenterIconStyle: { small: { [key: string]: any }; medium: { [key: string]: any }; large: { [key: string]: any }; extraLarge: { [key: string]: any } } & any;
  replayTopLeftIconStyle: { medium: { [key: string]: any }; large: { [key: string]: any }; extraLarge: { [key: string]: any } } & any;
  iconAndToolTipContainerStyle: { [key: string]: any };
  screenStyle: { [key: string]: any };
}

const replayBigCenterIcon = {
  cursor: 'pointer',
  small: {
    width: '32px',
    height: '32px',
  },
  medium: {
    width: '60px',
    height: '60px',
  },
  large: {
    width: '66px',
    height: '66px',
  },
  extraLarge: {
    width: '80px',
    height: '80px',
  },
};

const replayTopLeftIcon = {
  cursor: 'pointer',
  color: SITE_VARIABLES.COLORS.WHITE,
  width: '20px',
  height: '20px',
  medium: {
    margin: '10px 10px',
  },
  large: {
    margin: '8px 8px',
  },
  extraLarge: {
    margin: '16px 16px',
  },
};

const iconAndToolTipContainer = {
  position: 'relative',
  display: 'grid',
};

const screen = (showReplayBigCenterIcon: boolean): { [key: string]: any } => {
  const flexObject = showReplayBigCenterIcon ? flexColumnCenterCenter : flexColumnStart;
  return ({
    ...flexObject,
    pointerEvents: 'auto',
    width: '100%',
    height: '100%',
    position: 'absolute',
    backdropFilter: 'blur(3px)',
    webkitBackdropFilter: 'blur(3px)',
    backgroundColor: SITE_VARIABLES.COLORS.BLUR_TRANSPARENT,
  });
};

export const getReplayVideoStyleObject = (playerSize: PlayerSizesTypes, showReplayBigCenterIcon: boolean): StylesObject => {
  const smallSize = playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';
  const screenObject = screen(showReplayBigCenterIcon);

  return ({
    replayBigCenterIconStyle: [
      replayBigCenterIcon,
      smallSize && replayBigCenterIcon.small,
      mediumSize && replayBigCenterIcon.medium,
      largeSize && replayBigCenterIcon.large,
      extraLargeSize && replayBigCenterIcon.extraLarge,
    ],
    replayTopLeftIconStyle: [
      replayTopLeftIcon,
      mediumSize && replayTopLeftIcon.medium,
      largeSize && replayTopLeftIcon.large,
      extraLargeSize && replayTopLeftIcon.extraLarge,
    ],
    iconAndToolTipContainerStyle: {
      ...iconAndToolTipContainer,
    },
    screenStyle: {
      ...screenObject,
    },
  });
};

export const getTooltipMarginLeft = (playerSize: PlayerSizesTypes): string => {
  if (playerSize === 'medium') {
    return '10px';
  }
  if (playerSize === 'large') {
    return '8px';
  }
  if (playerSize === 'extraLarge') {
    return '16px';
  }
  return '0px';
};
